<template>
  <div class="scene home-scene">

    <template v-if="!backgroundIsTransitioning">

      <div class="home-scene__info">
        <div class="home-scene__text-above-heading">{{homePageTextAboveHeading}}</div>
        <div class="home-scene__heading">{{homePageHeading}}</div>
        <div class="home-scene__description">{{homePageTextBelowHeading}}</div>
      </div>

      <div class="home-scene__sog-logo"><img src="images/sog-logo.png"/></div>
      
      <div class="home-scene__ministry-logo"><img src="images/ministry-logo.png"/></div>

      <nav class="site-navigation">
          <div class="site-navigation__items">
              <router-link to="/challenges" class="site-navigation__item site-navigation__item--current">
                <span>{{homePageTextOverButton}}</span>
              </router-link>
          </div>
          <div @click="enterSite" class="site-navigation__button site-navigation__button--arrow-down"></div>
      </nav>

      <div class="disclaimer" v-html="mapDisclaimer"></div>

    </template>

  </div>
</template>

<script>
import store from '@/dataStore';

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      // NOTE(Mølby): Text strings
      homePageTextAboveHeading: '',
      homePageHeading: '',
      homePageTextBelowHeading: '',
      homePageTextOverButton: '',
      mapDisclaimer: '',
      backgroundIsTransitioning: false
    }
  },
  created()
  {
    store.setGlobeState('autospin');

    this.unsubscribeFromStore = store.subscribe((storeState)=>{
        this.homePageTextAboveHeading = storeState.siteInfo.homePageTextAboveHeading;
        this.homePageHeading = storeState.siteInfo.homePageHeading;
        this.homePageTextBelowHeading = storeState.siteInfo.homePageTextBelowHeading;
        this.homePageTextOverButton = storeState.siteInfo.homePageTextOverButton;
        this.mapDisclaimer = storeState.siteInfo.mapDisclaimer;
        this.backgroundIsTransitioning = storeState.backgroundIsTransitioning;
    });
  },
  unmounted()
  {
    this.unsubscribeFromStore();
  },
  methods:
  {
    enterSite()
    {
      this.$router.push('/challenges/');
    }
  }
}
</script>
